import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DropdownItem } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Modal from "../Modal";
import Loader from "@components/Loader";
import PaymentCardDetails from "../PaymentCardDetails";
import Dropdown from "../Dropdown";
import PaymentCardBrandIcon from "../PaymentCardBrandIcon";
import { deleteCard } from "@redux/paymentCards/actions";
import { ReactComponent as IconShowMore } from "../../assets/ic-show-more.svg";

import styles from "./index.module.scss";

const PaymentCard = ({ id, short }) => {
  const { t } = useTranslation("payment-methods");
  const { t: t1 } = useTranslation("modals");
  const { t: t2 } = useTranslation("buttons");
  const { t: t3 } = useTranslation("common");
  const dispatch = useDispatch();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  const card =
    useSelector(({ cardsReducer }) => cardsReducer?.cardsById?.[id]) || {};
  const {
    lastFourNumbers,
    paymentSystem,
    expMonth,
    expYear,
    isDeleting,
    hasActiveSubscriptions,
  } = card;

  const deleteText = hasActiveSubscriptions
    ? "DELETE_CARD_BODY"
    : "DELETE_CARD_BODY_NO_SUBS";

  const toggleDelete = () => setIsDeleteOpen((state) => !state);
  const toggleDetails = () => setIsDetailsOpen((state) => !state);

  const handleDelete = () => {
    dispatch(deleteCard({ id }));
    toggleDelete();
  };

  if (expYear === 0) {
    return (
      <div
        className={classNames(
          "d-flex border-dark-grey align-items-center justify-content-center py-4",
          styles.gap,
          styles.card,
        )}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "d-flex border-dark-grey",
        styles.gap,
        !short && styles.card,
      )}
    >
      <PaymentCardDetails
        id={id}
        isOpen={isDetailsOpen}
        toggle={toggleDetails}
      />
      <Modal
        centered
        title={t1("DELETE_CARD_TITLE")}
        toggle={toggleDelete}
        onCancel={toggleDelete}
        onClose={toggleDelete}
        onConfirm={handleDelete}
        isOpen={isDeleteOpen}
        size="sm"
        bodyClassName="pt-3"
        confirmText={t3("DELETE")}
        cancelText={t2("CANCEL")}
        cancelClassName="mb-xl-0 mb-3"
      >
        <div className="text-center text-body-1 text-primary">
          <div>{t1(deleteText)}</div>
        </div>
      </Modal>
      <div>
        <PaymentCardBrandIcon brand={paymentSystem} />
      </div>
      <div className="w-100 text-body-1 text-regular">
        <div className={classNames("text-primary d-flex mb-1", styles.gap)}>
          <span>{`**** ${lastFourNumbers}`}</span>
        </div>
        {!short && (
          <div className="text-tertiary">
            {t("EXPIRES", {
              expMonth,
              expYear: `${expYear}`.slice(-2),
            })}
          </div>
        )}
      </div>
      {!short && (
        <Dropdown
          end
          disabled={isDeleting}
          toggler={<IconShowMore />}
          togglerClassName={classNames("btn-resetStyle text-secondary")}
          menuClassName={classNames("w-auto", styles.dropdownMenu)}
        >
          <DropdownItem onClick={toggleDetails}>
            {t("VIEW_DETAILS")}
          </DropdownItem>
          <DropdownItem onClick={toggleDelete}>{t("DELETE_CARD")}</DropdownItem>
        </Dropdown>
      )}
    </div>
  );
};

export default PaymentCard;
